module.exports = __webpack_public_path__ + "static/media/hot.c38e10f0.png";